import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router";
import { CheckIcon } from "../../../../assets";
import { sendResetPasswordLink } from "../../../services";
import { getIsIpDomain } from "../../../utils";
import { Copyright, Pagewrapper } from "../../components";
import { PDLButton, PDLTypography } from "../../components/dna";
import ForgotPasswordForm from "../../components/global/_forgotPasswordForm";

import "./index.scss";

const ForgotPassword = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const isIpDomain = getIsIpDomain();

  const navigate = useNavigate();

  const handleSendLink = async (email: string) => {
    setError("");

    try {
      setLoading(true);
      await sendResetPasswordLink(email);
      setSuccess(true);
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      setError(
        err.response?.data?.message ||
          "Erro ao enviar link de redefinição de senha.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isIpDomain) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Pagewrapper {...props}>
      <Container fluid className="pdl_page_forgot_password">
        <Row className="h-100">
          <Col sm={6} className="h-100 pdl_page_forgot_password_column_left">
            <Container className="h-100 d-flex flex-column align-items-center justify-content-between">
              <Row></Row>
              <Row className="pdl_page_forgot_password_form_container">
                <Col>
                  {success ? (
                    <div className="forgot_password_success">
                      <div className="forgot_password_success_icon">
                        <CheckIcon />
                      </div>

                      <div className="d-grid gap-4 mb-4">
                        <PDLTypography display size="md" weight="semibold">
                          Link enviado!
                        </PDLTypography>
                        <PDLTypography size="md">
                          Se existir uma conta para o e-mail informado, enviamos
                          um link para redefinição da senha.
                        </PDLTypography>
                      </div>

                      <PDLButton
                        type="button"
                        variant="primary"
                        className="w-100 mb-4"
                        onClick={() => navigate(-1)}
                        size="lg"
                      >
                        Voltar para o login
                      </PDLButton>

                      <PDLTypography size="xs">
                        Verifique também sua caixa de spam.
                      </PDLTypography>
                    </div>
                  ) : (
                    <>
                      <ForgotPasswordForm
                        onSubmit={handleSendLink}
                        loading={loading}
                      />

                      {error && <p className="form_error mt-3">{error}</p>}
                    </>
                  )}
                </Col>
              </Row>
              <Row className="w-100">
                <Col className="py-3 justify-self-stretch">
                  <Copyright />
                </Col>
              </Row>
            </Container>
          </Col>
          <Col
            sm={6}
            className="h-100 pdl_page_forgot_password_column_right d-none d-sm-block"
          >
            <Container className="h-100 p-0 m-0 d-flex flex-column align-items-center justify-content-center">
              <Row>
                <Col className="pdl_page_forgot_password_column_right_contents p-0 m-0 text-center d-grid gap-5">
                  <img
                    alt="Plataforma LEX"
                    className="pdl_page_forgot_password_image_plataforma rounded"
                    src="/images/generic/plataforma_lex.png"
                  />
                  <div className="d-grid gap-2">
                    <PDLTypography size="xl" variant="light" weight="medium">
                      Boas vindas à Plataforma LEX
                    </PDLTypography>
                    <PDLTypography size="md" variant="light" weight="medium">
                      Sua fonte central de pesquisa jurídica, com conteúdos
                      confiáveis e atualizados.
                    </PDLTypography>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </Pagewrapper>
  );
};

export default ForgotPassword;
